const initialState = {
    openData: [],
    origOpenData: [],
    pageNo: 0,
    sortOrder: '',
    domainFilter: [],
    count: 0,
    tabSearchValue: '',
    isLoading: false,
    selectedQuestion: null,
    selectedOpenQuestionUuid: '',
    selectedOpenQuestionUuidWatchlist: '',
    selectedQuestionData: {},
    reloadPage: 'refresh',
    sortChange:false,
    relevanceObj : {id:'3',value:"Relevance",label:"Relevance", origValue:'relevance', sortOrder:'asc'},
    sortOptions: [
        { id:'1',value: "recently asked", label: "Latest Asked", origValue:'questionAsked', sortOrder:'desc' },
        { id:'2',value: "oldest asked", label: "Oldest Asked", origValue:'questionAsked', sortOrder:'asc' },
      ],
    sortFilterVal: { id:"1",value: "recently asked", label: "Latest Asked", origValue:'questionAsked', sortOrder:'desc' },
    keytagsData:null
}

const openPageReducer = (state = initialState, action) => {
    switch (action.type) {
        case "updatepagenumberopentab":
            state = { ...state, pageNo: action.payload };
            return state;
        case "getquestiontext":
            state = { ...state, selectedOpenQuestionUuidWatchlist: action.payload };
            return state;
        case "sortChangeOpenPage":
            state={...state,sortChange:action.payload };
        return state;
        case "openquestionsdata":
            state = { ...state, pageNo: 0 };
            state = { ...state, openData: action.payload };
            return state;
        case "openquestionsloading":
            state = { ...state, isLoading: action.payload };
            return state;
        case "updateopentabdata":
            state = { ...state, isLoading: false };
            state = { ...state, origOpenData: action.payload };
            state = { ...state, openData: action.payload };
            return state;
        case "openquestionssortfilter":
            state = { ...state, pageNumber: 0 };
            state = { ...state, sortOrder: action.payload };
            return state;
        case "openquestionscount":
            state = { ...state, count: action.payload };
            return state;
        case "updateOpentabSearchValue":
            state = { ...state, tabSearchValue: action.payload };
            return state;
        case "updatedomainsopentab":
            state = { ...state, domainFilter: action.payload };
            return state;
        case "deleteopenquestions":
            const questionId = action.payload;
            state = { ...state, openData: state.openData.filter(question => question.questionUuid !== questionId) };
            return state;
        case "deleteselectedquestionUuid":
            state = { ...state, selectedOpenQuestionUuid: action.payload };
            return state;
        case "getselectedquestionUuidWatchlist":
            state = { ...state, selectedOpenQuestionUuidWatchlist: action.payload };
            return state;
        case "updatesortorderdata":
            state = { ...state, pageNumber: 0 };
            state = { ...state, openData: action.payload };
            return state;
        case "selectedquestiondatainopentab":
            state = { ...state, selectedQuestionData: action.payload };
            return state;
        case "addrelevance":
            state = { ...state, relevanceObj: action.payload };
            return state;
        case "sortfiltervalueadd":
            state = { ...state, sortFilterVal: action.payload };
            return state;
        case "reloadOpenPage":
            state = { ...state, reloadPage: action.payload };
            return state;
        case "updatesortOpenOption":
            state = { ...state, sortOptions: action.payload };
            return state;
        case "getKeyTagsDataOpen" : 
        state = {...state, keytagsData:action.payload};
        return state;
        default:
            return state;
    }
}

export default openPageReducer;